export default "__VITE_ASSET__CqYOYFEW__"